// extracted by mini-css-extract-plugin
module.exports = {"payment-gateways":"PaymentGateways_payment-gateways__3w9aL"};